webpackJsonp([212],{

/***/ 1211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PositionForm_vue__ = __webpack_require__(2923);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f6e8733_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PositionForm_vue__ = __webpack_require__(5221);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PositionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f6e8733_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PositionForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRule;
/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:04
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-26 12:37:26
 */

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 */
function makeRule(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'string';
  var trigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'blur';
  var required = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var rule = { message: message, type: type, trigger: trigger, required: required };
  rule.transform = function (value) {
    // 为空字符串时转换为null
    value === '' && (value = null);
    // 数字类型忽略为null的数字转换
    if (value !== null && ['number', 'integer', 'float'].includes(type)) {
      value = Number(value);
    }
    return value;
  };
  return rule;
}

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1357), __esModule: true };

/***/ }),

/***/ 1357:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1358);


/***/ }),

/***/ 1358:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(41);
var get = __webpack_require__(145);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1376:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1381);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1352);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1382), __esModule: true };

/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(234);
__webpack_require__(143);
module.exports = __webpack_require__(1383);


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(146);
var ITERATOR = __webpack_require__(22)('iterator');
var Iterators = __webpack_require__(66);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 2070:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return searchRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__ = __webpack_require__(1345);



var searchRules = {
  up_date: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择发布时间段', 'string'))],
  industry_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择行业大类', 'integer'))],
  position_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择职业类型', 'integer'))],
  title: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入岗位名称', 'string'))],
  employer_name: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入发布单位', 'string'))],
  hire_number: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入招聘人数', 'integer')), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入大于0的整数', 'integer'), { min: 1 })],
  address: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工作地点', 'string'))],
  employer_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入发布单位', 'string'))],
  position_period: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择工作时间', 'string'))],
  working_shifts: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择工作班次', 'string'))],
  working_hours: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工作时长', 'number'))],
  gender: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择性别要求', 'integer'))],
  certificate: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入证件要求', 'string'))],
  working_experience: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入工作经验', 'string'))],

  salary: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入基本薪资', 'integer'))],
  salary_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择薪资方式', 'integer'))],
  settlement_type: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请输入结算方式', 'integer'))],
  settlement_time: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择结算时间', 'integer'))],
  area_id: [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_rule_js__["a" /* makeRule */])('请选择区', 'integer'))]
};

/***/ }),

/***/ 2923:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__position_rules_js__ = __webpack_require__(2070);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchRules: __WEBPACK_IMPORTED_MODULE_2__position_rules_js__["a" /* searchRules */],
      selectLoading: false,
      form: {
        id: this.$route.params.id,
        up_date: null,
        down_date: null,
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: 0,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        province_id: [],
        city_id: [],
        area_id: []
      },
      options: {
        industry_type: [],
        position_type: [],
        salary: [],
        salary_type: [],
        gender: [],
        settlement_type: [],
        settlement_time: [],
        education: [],
        marriage: [],
        insurance: [],
        province_id: [],
        city_id: [],
        area_id: []
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    var _this = this;

    request.all.page([request('getProvinceList'), request('editPostionOptions'), request('getPostionForm', this.form.id)]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
          province = _ref2[0],
          options = _ref2[1],
          form = _ref2[2];

      (function (data) {
        _this.options.province_id = data.data;
      })(province);(function (data) {
        filter.setLoop(_this.options, data.data);
      })(options);(function (data) {
        filter.setLoop(_this.form, data.data);
        request.all.page([request('getCityList', _this.form.province_id), request('getAreaList', _this.form.city_id)]).then(function (_ref3) {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
              city = _ref4[0],
              area = _ref4[1];

          (function (data) {
            _this.options.city_id = data.data;
          })(city);(function (data) {
            _this.options.area_id = data.data;
          })(area);
        });
      })(form);
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions(['getPostionForm', 'editPostionOptions', 'modifyPostion', 'getProvinceList', 'getCityList', 'getAreaList']), {
    onSubmitForm: function onSubmitForm() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (_this2.form.salary_type === 3) {
            _this2.form.salary = 0;
          } else if (_this2.form.salary === -1) {
            _this2.$message.error('请选择基本薪资');
            return false;
          }
          return request.common('modifyPostion', _this2.form).then(function (data) {
            _this2.$message({
              showClose: true,
              message: '修改成功',
              type: 'success'
            });
          });
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    remoteCityMethod: function remoteCityMethod(id) {
      var _this3 = this;

      request.common('getCityList', id).then(function (data) {
        _this3.options.city_id = data.data;
        _this3.form.city_id = '';
        _this3.form.area_id = '';
      });
    },
    remoteAreaMethod: function remoteAreaMethod(id) {
      var _this4 = this;

      request.common('getAreaList', id).then(function (data) {
        _this4.options.area_id = data.data;
        _this4.form.area_id = '';
      });
    }
  })

});

/***/ }),

/***/ 5221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.$route.meta.title)+"\n    ")]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("招聘管理")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/position/table'}}},[_vm._v("职位列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"show-header":false}},[_c('el-form',{ref:"form",staticClass:"demo-ruleForm",attrs:{"model":_vm.form,"rules":_vm.searchRules,"label-width":"120px"}},[_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("基本信息")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"up_date","label":"发布时间:"}},[_c('el-col',{attrs:{"span":24}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"开始日期","value-format":"yyyy-MM-dd"},model:{value:(_vm.form.up_date),callback:function ($$v) {_vm.$set(_vm.form, "up_date", $$v)},expression:"form.up_date"}}),_vm._v("\n            ~\n            "),_c('el-date-picker',{attrs:{"type":"date","placeholder":"结束日期","value-format":"yyyy-MM-dd"},model:{value:(_vm.form.down_date),callback:function ($$v) {_vm.$set(_vm.form, "down_date", $$v)},expression:"form.down_date"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"industry_type","label":"行业大类:"}},[_c('el-select',{attrs:{"placeholder":"请选择行业大类"},model:{value:(_vm.form.industry_type),callback:function ($$v) {_vm.$set(_vm.form, "industry_type", $$v)},expression:"form.industry_type"}},_vm._l((_vm.options.industry_type),function(industryType,index){return _c('el-option',{key:index,attrs:{"label":industryType.keyword,"value":industryType.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"position_type","label":"职位类型:"}},[_c('el-select',{attrs:{"placeholder":"请选择职位类型"},model:{value:(_vm.form.position_type),callback:function ($$v) {_vm.$set(_vm.form, "position_type", $$v)},expression:"form.position_type"}},_vm._l((_vm.options.position_type),function(positionType,index){return _c('el-option',{key:index,attrs:{"label":positionType.keyword,"value":positionType.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"title","label":"岗位名称:"}},[_c('el-input',{model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"hire_number","label":"招聘人数:"}},[_c('el-input',{model:{value:(_vm.form.hire_number),callback:function ($$v) {_vm.$set(_vm.form, "hire_number", $$v)},expression:"form.hire_number"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"address","label":"工作地点:"}},[_c('el-input',{model:{value:(_vm.form.address),callback:function ($$v) {_vm.$set(_vm.form, "address", $$v)},expression:"form.address"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"area_id","label":"省市区:"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{attrs:{"filterable":"","remote":"","reserve-keyword":"","placeholder":"请选择省","loading":_vm.selectLoading,"auto-complete":"province_id"},on:{"change":_vm.remoteCityMethod},model:{value:(_vm.form.province_id),callback:function ($$v) {_vm.$set(_vm.form, "province_id", $$v)},expression:"form.province_id"}},_vm._l((_vm.options.province_id),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":parseInt(item.id)}})}),1),_vm._v("    \n            "),_c('el-select',{attrs:{"filterable":"","remote":"","reserve-keyword":"","placeholder":"请选择市","loading":_vm.selectLoading,"auto-complete":"cit_id"},on:{"change":_vm.remoteAreaMethod},model:{value:(_vm.form.city_id),callback:function ($$v) {_vm.$set(_vm.form, "city_id", $$v)},expression:"form.city_id"}},_vm._l((_vm.options.city_id),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":parseInt(item.id)}})}),1),_vm._v("    \n            "),_c('el-select',{attrs:{"filterable":"","remote":"","reserve-keyword":"","placeholder":"请选择区","loading":_vm.selectLoading,"auto-complete":"area_id"},model:{value:(_vm.form.area_id),callback:function ($$v) {_vm.$set(_vm.form, "area_id", $$v)},expression:"form.area_id"}},_vm._l((_vm.options.area_id),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":parseInt(item.id)}})}),1)]}}])}),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"employer_name","label":"发布单位:"}},[_c('el-input',{model:{value:(_vm.form.employer_name),callback:function ($$v) {_vm.$set(_vm.form, "employer_name", $$v)},expression:"form.employer_name"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("职位描述")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作时间:","prop":"position_period"}},[_c('el-input',{model:{value:(_vm.form.position_period),callback:function ($$v) {_vm.$set(_vm.form, "position_period", $$v)},expression:"form.position_period"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作班次:","prop":"working_shifts"}},[_c('el-input',{model:{value:(_vm.form.working_shifts),callback:function ($$v) {_vm.$set(_vm.form, "working_shifts", $$v)},expression:"form.working_shifts"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作时长:","prop":"working_hours"}},[_c('el-input',{model:{value:(_vm.form.working_hours),callback:function ($$v) {_vm.$set(_vm.form, "working_hours", $$v)},expression:"form.working_hours"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"性别要求:","prop":"gender"}},[_c('el-select',{attrs:{"placeholder":"请选择性别要求"},model:{value:(_vm.form.gender),callback:function ($$v) {_vm.$set(_vm.form, "gender", $$v)},expression:"form.gender"}},_vm._l((_vm.options.gender),function(strgender,index){return _c('el-option',{key:index,attrs:{"label":strgender.keyword,"value":strgender.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"年龄要求:","prop":"age_range"}},[_c('el-input',{model:{value:(_vm.form.age_range),callback:function ($$v) {_vm.$set(_vm.form, "age_range", $$v)},expression:"form.age_range"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"证件要求:","prop":"certificate"}},[_c('el-input',{model:{value:(_vm.form.certificate),callback:function ($$v) {_vm.$set(_vm.form, "certificate", $$v)},expression:"form.certificate"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"学历要求:","prop":"education"}},[_c('el-select',{attrs:{"placeholder":"请选择学历要求"},model:{value:(_vm.form.education),callback:function ($$v) {_vm.$set(_vm.form, "education", $$v)},expression:"form.education"}},_vm._l((_vm.options.education),function(streducation,index){return _c('el-option',{key:index,attrs:{"label":streducation.keyword,"value":streducation.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"婚姻状况:","prop":"marriage"}},[_c('el-select',{attrs:{"placeholder":"请选择学历要求"},model:{value:(_vm.form.marriage),callback:function ($$v) {_vm.$set(_vm.form, "marriage", $$v)},expression:"form.marriage"}},_vm._l((_vm.options.marriage),function(strmarriage,index){return _c('el-option',{key:index,attrs:{"label":strmarriage.keyword,"value":strmarriage.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"工作经验:","prop":"working_experience"}},[_c('el-input',{model:{value:(_vm.form.working_experience),callback:function ($$v) {_vm.$set(_vm.form, "working_experience", $$v)},expression:"form.working_experience"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"补充说明:","prop":"other_requirements"}},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.form.other_requirements),callback:function ($$v) {_vm.$set(_vm.form, "other_requirements", $$v)},expression:"form.other_requirements"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-row',{staticClass:"text item"},[_c('el-col',{attrs:{"span":24}},[_c('h2',[_vm._v("薪资福利")]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"基本薪资:","prop":"salary"}},[_c('el-select',{attrs:{"placeholder":"请选择薪资范围"},model:{value:(_vm.form.salary),callback:function ($$v) {_vm.$set(_vm.form, "salary", $$v)},expression:"form.salary"}},[_c('el-option',{key:-1,attrs:{"label":"0","value":-1}}),_vm._v(" "),_vm._l((_vm.options.salary),function(type,index){return _c('el-option',{key:index,attrs:{"label":type.keyword,"value":type.id}})})],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"薪资方式:","prop":"salary_type"}},[_c('el-select',{attrs:{"placeholder":"请选择薪资方式"},model:{value:(_vm.form.salary_type),callback:function ($$v) {_vm.$set(_vm.form, "salary_type", $$v)},expression:"form.salary_type"}},_vm._l((_vm.options.salary_type),function(type,index){return _c('el-option',{key:index,attrs:{"label":type.keyword,"value":type.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"提成机制:","prop":"commission"}},[_c('el-input',{model:{value:(_vm.form.commission),callback:function ($$v) {_vm.$set(_vm.form, "commission", $$v)},expression:"form.commission"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"季度奖金:","prop":"quarterly_bonus"}},[_c('el-input',{model:{value:(_vm.form.quarterly_bonus),callback:function ($$v) {_vm.$set(_vm.form, "quarterly_bonus", $$v)},expression:"form.quarterly_bonus"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"社保缴纳:","prop":"insurance"}},[_c('el-select',{attrs:{"placeholder":"请选择社保缴纳"},model:{value:(_vm.form.insurance),callback:function ($$v) {_vm.$set(_vm.form, "insurance", $$v)},expression:"form.insurance"}},_vm._l((_vm.options.insurance),function(strinsurance,index){return _c('el-option',{key:index,attrs:{"label":strinsurance.keyword,"value":strinsurance.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"加班补助:","prop":"overtime_pay"}},[_c('el-input',{model:{value:(_vm.form.overtime_pay),callback:function ($$v) {_vm.$set(_vm.form, "overtime_pay", $$v)},expression:"form.overtime_pay"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"餐饮补助:","prop":"meal_allowance"}},[_c('el-input',{model:{value:(_vm.form.meal_allowance),callback:function ($$v) {_vm.$set(_vm.form, "meal_allowance", $$v)},expression:"form.meal_allowance"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"交通补助:","prop":"commute_allowance"}},[_c('el-input',{model:{value:(_vm.form.commute_allowance),callback:function ($$v) {_vm.$set(_vm.form, "commute_allowance", $$v)},expression:"form.commute_allowance"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"话费补助:","prop":"phone_allowance"}},[_c('el-input',{model:{value:(_vm.form.phone_allowance),callback:function ($$v) {_vm.$set(_vm.form, "phone_allowance", $$v)},expression:"form.phone_allowance"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"其他福利:","prop":"welfare"}},[_c('el-input',{model:{value:(_vm.form.welfare),callback:function ($$v) {_vm.$set(_vm.form, "welfare", $$v)},expression:"form.welfare"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结算方式:","prop":"settlement_strtype"}},[_c('el-select',{attrs:{"placeholder":"请选择结算方式"},model:{value:(_vm.form.settlement_type),callback:function ($$v) {_vm.$set(_vm.form, "settlement_type", $$v)},expression:"form.settlement_type"}},_vm._l((_vm.options.settlement_type),function(settlementStrtype,index){return _c('el-option',{key:index,attrs:{"label":settlementStrtype.keyword,"value":settlementStrtype.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"结算时间:","prop":"settlement_time"}},[_c('el-select',{attrs:{"placeholder":"请选择结算时间"},model:{value:(_vm.form.settlement_time),callback:function ($$v) {_vm.$set(_vm.form, "settlement_time", $$v)},expression:"form.settlement_time"}},_vm._l((_vm.options.settlement_time),function(settlementStrtime,index){return _c('el-option',{key:index,attrs:{"label":settlementStrtime.keyword,"value":settlementStrtime.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmitForm()}}},[_vm._v("修改\n          ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{ path: '/position/table' }}},[_c('el-button',[_vm._v("取消")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/212.17fba5f9e91aa6b9aba3.js